import { Link } from "react-router-dom";
import { ShieldCheck, MessageCircle, ArrowRight } from "lucide-react";

/**
 * Prominent, dismissible-free banner shown on every user dashboard.
 * Directs questions to the admin via the secure in-mail (Messages) inbox
 * rather than external email. All communication stays inside the platform
 * (end-to-end within our infra — no third-party email leaks).
 */
const AdminMessageCallout = ({ compact = false }) => {
  if (compact) {
    return (
      <Link
        to="/message-admin"
        className="flex items-center gap-3 px-4 py-3 rounded-xl bg-gradient-to-r from-[#EC008C]/10 to-[#EC008C]/5 border border-[#EC008C]/25 hover:border-[#EC008C]/50 transition-colors"
        data-testid="admin-inmail-callout-compact"
      >
        <ShieldCheck className="w-5 h-5 text-[#EC008C] flex-shrink-0" />
        <p className="text-xs text-[#C0C6D0] flex-1">
          Questions? <span className="text-white font-medium">Message Admin</span> via secure in-mail.
        </p>
        <ArrowRight className="w-4 h-4 text-[#EC008C]" />
      </Link>
    );
  }

  return (
    <Link
      to="/message-admin"
      className="mb-6 p-4 rounded-2xl bg-gradient-to-r from-[#EC008C]/10 via-[#EC008C]/5 to-transparent border border-[#EC008C]/25 hover:border-[#EC008C]/50 flex items-center gap-4 group transition-colors"
      data-testid="admin-inmail-callout"
    >
      <div className="w-11 h-11 rounded-xl bg-[#EC008C]/15 flex items-center justify-center flex-shrink-0">
        <ShieldCheck className="w-5 h-5 text-[#EC008C]" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-white font-semibold text-sm">
          Need help? Message Admin via secure in-mail.
        </p>
        <p className="text-[#8A92A0] text-xs mt-0.5">
          All messages are end-to-end within StardomFans — private, encrypted at rest, and never sent through third-party email.
        </p>
      </div>
      <span
        className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#EC008C] text-black font-semibold text-xs group-hover:bg-[#FF3399] transition-colors"
        data-testid="admin-inmail-callout-btn"
      >
        <MessageCircle className="w-3.5 h-3.5" /> Open In-Mail
      </span>
      <span
        className="sm:hidden inline-flex items-center justify-center w-10 h-10 rounded-full bg-[#EC008C] text-black"
        data-testid="admin-inmail-callout-btn-mobile"
      >
        <MessageCircle className="w-4 h-4" />
      </span>
    </Link>
  );
};

export default AdminMessageCallout;
